import { render } from "./AddBasicInput.vue?vue&type=template&id=667cc999&ts=true"
import script from "./AddBasicInput.vue?vue&type=script&lang=ts"
export * from "./AddBasicInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__